import {
  getEmeraldPrompt,
  getFileTemplate,
  getFolderTemplate,
} from '../constants';

export const getReactInitialPrompts = (
  html: string,
  css: string,
  version: string,
  styleType: string,
  projectName: string,
  userEmerald = false,
) => [
  {
    content: `** CONTEXT:** Identify reusable code sections from the provided HTML and CSS, and convert them into ReactJs-specific reusable components. For each identified component, generate the following files:
  ComponentName.tsx (Component logic)
  ComponentName.test.tsx (Unit test)
  ComponentName.module.${styleType} (Style file)
  **INFORMATION ABOUT MY INPUT**
  HTML Code: ${html}
  CSS Code: ${css}
  React Version: ${version || '18.x'}
  Style Type: ${styleType} (e.g., scss, css)
  Project Name: ${projectName || 'Test'}
  ** OBJECTIVES **
  Extract reusable UI elements and convert them into multiple ReactJs components for each repeated code pattern. You can derive component names based on the HTML structure.
  You can follow a Component naming convention based on the semantic purpose or visual structure of the HTML elements. use naming convention (e.g., kebab-case).
  Some common enhancements you might consider:
  Hover effects (e.g., tooltips, color changes)
  Toggle states (e.g., active/inactive)
  Accessibility features (e.g., ARIA labels)
  Keyboard navigation support
  Confirmation dialogs before executing actions
  Loading indicators for async operations
  Assume each element has an Input label (e.g., 'Accept', 'Reject') and an Output for the click event object, if applicable.. Assume a click event for all buttons, icons, etc...
  Maintain parent-child relationships between components where applicable.
  Ensure code readability by including \n where appropriate.
  **OUTPUT FORMAT**
  Provide a complete React project structure, ready to build.
  Prefix each file with '**File:**' followed by the full relative path from the project root with including project name ${
    projectName || 'Test'
  }.
  Do not use numbering for file names.
  ** RULES:**
  Derive component names based on the structure and semantics of the provided HTML.
  Use only identified HTML attributes and content for input bindings.
  Use $event for all output click events.
  Include meaningful and basic test cases in each .test.tsx file.
  Maintain a consistent and clean folder structure for all generated files.
  Must maintain prefix of each file with '**File:**' followed by the full relative path from the project root path with including project name ${
    projectName || 'Test'
  }
  ${userEmerald ? getEmeraldPrompt(html, 'react')?.prompt : ''}`,
    role: 'system',
  },
];

export const getPublicFolderTemplate = (assets: any): any => {
  return {
    ...getFolderTemplate(),
    name: 'public',
    open: true,
    children: [
      {
        ...getFolderTemplate(),
        name: 'images',
        open: false,
        children:
          !assets || Object.keys(assets).length === 0
            ? []
            : Object.keys(assets).map((eachKey: any) => {
                return {
                  ...getFileTemplate(),
                  name: eachKey,
                  language: 'html',
                  extension: 'svg',
                  content: assets[eachKey],
                };
              }),
      },
      {
        ...getFolderTemplate(),
        name: 'fonts',
        open: false,
        children: [],
      },
    ],
  };
};

// const getReactEmeraldComponentMetadata = () => {
//   return `Use below component library for Button and Icon components.
//  [{
//     importPath: "@emerald-react/button"
//     componentTag: "EmeraldButton"
//     name: 'Emerald Button',
//     inputs: [{
//         type: "string",
//         label: "string",
//         icon: "string",
//         iconPosition: "string",
//         outlined: "boolean",
//         type: "Primary|Secondary|Text|Light"
//     }],
//     description: "Button component for the emerald-react library"
//  },
//  {
//     importPath: "@emerald-react/icon"
//     componentTag: "EmeraldIcon"
//     name: 'Emerald Icon',
//     inputs: [{
//         icon: "string",
//         outlined: "boolean"
//     }],
//     description: "Icon component for the emerald-react library"
//  }
//  ]`;
// };
